const defaultCriteria = {
  credit_score: 600,
  monthly_income: 3000,
  rental_debt: 1000,
  collections: 500,
  other_debts: 100,
  monthly_debt_service: 500,
  bankruptcy: 0,
  voucher: "no",
  eviction_history_had_judgments: null,
  eviction_history_had_eviction_case_dismissed: "yes",
  most_recent_eviction: 1,
  criminal_history_been_arrested: null, 
  criminal_history_charged_misdemeanor: null, 
  criminal_history_charged_felony: null, 
  criminal_history_convicted_misdemeanor: null, 
  criminal_history_convicted_felony: "yes", 
  most_recent_criminal: 5
}

export default defaultCriteria;

